export enum Role {
    STANDARD = 'STANDARD',
    ADMIN = 'ADMIN',
    AZURE_ADMIN = 'AZURE_ADMIN'
}
